import { ThemeUICSSObject } from 'theme-ui';
import { spacing } from '../../../../util';
/* IMPORT HERE */

export const captcha: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(2),

  '.captcha__imageContainer': {
    border: '1px solid',
    borderColor: 'palette.border.field',
    p: spacing(4),
  },

  '.captcha__inputContainer': {
    display: 'flex',
    gap: spacing(2),
    justifyContent: 'stretch',

    input: {
      flexGrow: 1,
      width: '100%',
    },

    '.captcha__buttons': {
      width: '24px',
      flexDirection: 'column',
      display: 'flex',
      gap: spacing(2),
      flexShrink: 0,

      button: {
        width: '24px',
        height: '24px',
        p: '5px',
        variant: 'buttons.icon-outline',

        svg: {
          color: 'palette.text.primary',
          height: '16px',
          width: '16px',
        },
      },
    },
  },
};
